export default "https://cdn-static.gokick.com/assets/3258f73df43fa954b49bc6bd6de466cccdb5fe2c/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";